import { forwardRef, type Ref, type SVGProps } from "react";
const IconTreeBenchOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27.52 8.6A5 5 0 0 0 28 6.5 4.27 4.27 0 0 0 24 2a4.27 4.27 0 0 0-4 4.5 5 5 0 0 0 .48 2.1A6.41 6.41 0 0 0 18 13.7a6.22 6.22 0 0 0 5 6.21V29a1 1 0 0 0 2 0v-9.09a6.22 6.22 0 0 0 5-6.21 6.41 6.41 0 0 0-2.48-5.1M25 17.85V12a1 1 0 0 0-2 0v5.85a4.27 4.27 0 0 1-3-4.19 4.44 4.44 0 0 1 1.73-3.5 2 2 0 0 0 .56-2.42A2.9 2.9 0 0 1 22 6.5 2.3 2.3 0 0 1 24 4a2.3 2.3 0 0 1 2 2.5 2.9 2.9 0 0 1-.29 1.24 2 2 0 0 0 .56 2.42A4.46 4.46 0 0 1 28 13.7a4.25 4.25 0 0 1-3 4.15M5 23h11a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1m1-5h9v3H6zm12 7H3a1 1 0 0 0 0 2h1v2a1 1 0 0 0 2 0v-2h9v2a1 1 0 0 0 2 0v-2h1a1 1 0 0 0 0-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTreeBenchOutlineSVG);
ForwardRef.displayName = "IconTreeBenchOutline";
export { ForwardRef as IconTreeBenchOutline };
